import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';


import { bmincomingattendees, BMIncomingSurveyEntry, bmsurveyQAList, bmincoming } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { UserService } from '../../../services/user.service';
import { formatDate } from '@angular/common';
declare var google: any;
@Component({
  selector: 'app-survey-view',
  templateUrl: './survey-view.component.html',
  styleUrls: ['./survey-view.component.css']
})
export class SurveyViewComponent implements OnInit {
  isSubmitted: boolean = false;
  isSuccess: boolean = false;
  isSurvey: boolean = false;
  isFeedBack: boolean = false;
  isValidEmail: boolean = true;
  visitTrackUno: number;
  organization: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  mobileNumber: string = '';
  feedBack: string = '';
  objBMIncomingAttendees = new bmincomingattendees();
  currentDate:any =formatDate(new Date(), 'dd-MM-yyy', 'en-US')
  currentIndex: number = 1;
  questionCount: number = 0;
  level: number = 0;
  objQAList: any = [];
  objAnswerItems: any = [];
  modules_object: any = [];
  attendeeID: number;
    login_UserID: any;
    userList: any;
  companyLogo: any ="/assets/v2/img/login-logo-ring.png";
  constructor(public restApi: BMApiService, private toaster: ToasterService, private userService: UserService,private _activatedRoute: ActivatedRoute, private spinner: SpinnerVisibilityService) {

  }

  ngOnInit() {
    this.userService.CheckLogin();
    $('#main-menu').css('display', 'none');
    this._activatedRoute.params.subscribe((params: Params) => {
      
      if (params['id'] != null) {
        this.visitTrackUno = params['id'];
        let atdUno = location.href.split('atdUno=');
        this.attendeeID = atdUno.length!=2 ? 0 : Number(atdUno[1]);
        if (Number(this.attendeeID) > 0) {
          this.getAttendee(this.attendeeID);
          this.isSuccess = true;
          this.isSurvey = true;
        }
        this.userList = this.userService.getUserInfo();
        this.login_UserID = this.userList.id;
        this.LoadBMIncoming();
        this.getQuestionAnswerList();
      }
    });
  

  }

  addAttendees() {
    
    this.isSubmitted = true;
    if (this.email != '') {
      if (this.validateEmail(this.email)) {
        this.isValidEmail = true;
       
      }
      else {
      this.isValidEmail = false;
        return false;
      }
    }
    

    if (this.organization != ''&& this.email != '' ) {
      
      this.objBMIncomingAttendees.visitTrackUno = this.visitTrackUno;
      this.objBMIncomingAttendees.firstName = this.firstName;
      this.objBMIncomingAttendees.organization = this.organization;
      this.objBMIncomingAttendees.lastName = this.lastName;
      this.objBMIncomingAttendees.email = this.email;
      this.objBMIncomingAttendees.mobileNumber = this.mobileNumber;
      this.objBMIncomingAttendees.condition = 0;
      this.objBMIncomingAttendees.userUno = this.login_UserID;
      this.restApi.addEditBMIncomingAttendees(this.objBMIncomingAttendees)
        .subscribe(data=> {
          
          
          if (data != null && data != 'failure') {
            let id = parseInt(data.toString());
            this.attendeeID = id;

            this.isSuccess = true;
            this.spinner.hide();

            this.organization = '';
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.mobileNumber = '';
            this.isSubmitted = false;
          }
          else {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Please enter the required information.');
          this.spinner.hide();
        }
          



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    }
    return false;
  }
  onClickSurvery() {
    this.onUpdateStartEntry(2);
    this.isSurvey = true;
    return false;
  }
  onkeypress(e) {
    this.isSubmitted = false;
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }


  getQuestionAnswerList() {

    let inpValue = new bmsurveyQAList();
    inpValue.bmIncomingUno = this.visitTrackUno;
    inpValue.userUno = this.login_UserID; 
    this.restApi.getBMIncomingSurveyQAList(inpValue)
      .subscribe(data => {
        
        this.objQAList = data;
        this.questionCount = (this.objQAList.length > 1) ? (this.objQAList.length - 1) : 1;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

    //let objQAList = [{
    //  "question": "Question 1",
    //  "questionUno": "1",
    //  "options": [
    //    {
    //      "optionUno":"1",
    //      "optionText": "Answer 1",
    //      "optionValue": "1",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "2",
    //      "optionText": "Answer 2",
    //      "optionValue": "2",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "3",
    //      "optionText": "Answer 3",
    //      "optionValue": "3",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "4",
    //      "optionText": "Answer 4",
    //      "optionValue": "4",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "5",
    //      "optionText": "Answer 5",
    //      "optionValue": "5",
    //      "selectedoptionValue": ""
    //    }
    //  ]
    //},
    //{
    //  "question": "Question 2",
    //  "questionUno": "2",
    //  "options": [
    //    {
    //      "optionUno": "6",
    //      "optionText": "Answer 1",
    //      "optionValue": "1",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "7",
    //      "optionText": "Answer 2",
    //      "optionValue": "2",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "8",
    //      "optionText": "Answer 3",
    //      "optionValue": "3",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "9",
    //      "optionText": "Answer 4",
    //      "optionValue": "4",
    //      "selectedoptionValue": ""
    //    }
    //  ]
    //},
    //{
    //  "question": "Question 3",
    //  "questionUno": "3",
    //  "options": [
    //    {
    //      "optionUno": "10",
    //      "optionText": "Answer 1",
    //      "optionValue": "1",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "11",
    //      "optionText": "Answer 2",
    //      "optionValue": "2",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "12",
    //      "optionText": "Answer 3",
    //      "optionValue": "3",
    //      "selectedoptionValue": ""
    //    },
    //    {
    //      "optionUno": "13",
    //      "optionText": "Answer 4",
    //      "optionValue": "4"
    //    },
    //    {
    //      "optionUno": "14",
    //      "optionText": "Answer 5",
    //      "optionValue": "5",
    //      "selectedoptionValue": ""
    //    }
    //  ]
    //}];
    //this.objQAList = objQAList;

   
  }
  onItemChange(item,QUno) {
    

    let itementry = this.objQAList;
    if (this.objAnswerItems.length > 0) {
      for (var i = 0; i < this.objAnswerItems.length; i++) {
        if (this.objAnswerItems[i].QUno == QUno) {
          this.objAnswerItems.splice(i, 1);
          break;
        }
      }
    }
    item.selectedoptionValue = item.optionUno;

    let objAnswer = {
      QUno: QUno,
      optionUno: item.optionUno,
      optionValue: item.optionValue
    }
    this.objAnswerItems.push(objAnswer);
  }
  onClickPrev() {
    let index = this.currentIndex;
    if (index == 1) {
      return false;
    }
    else
    {
      this.currentIndex = (index > 1)?(index - 1):1;
    }
    
  }

  onClickNext() {
    
        
    let index = this.currentIndex;
    if (index > (this.questionCount)) {
      return false;
    }
    else {
      this.currentIndex = (index <= (this.questionCount)) ? (index + 1) : index;
    }

    
  }

  onSubmitAnswer() {
    
    if (this.objQAList.length == this.objAnswerItems.length) {
      this.AddEditSurveyEntry();
     
    }
    else {
      //Swal.fire('Error', 'Please answer the all questions.', 'error'); return;
      this.toaster.show('warning', 'Warning', 'Please answer the all questions.');
    }
    return false;
  }

  onClickFeedback() {
    

    if (this.feedBack != '') {
      this.objBMIncomingAttendees = new bmincomingattendees();
      this.objBMIncomingAttendees.bmIncomingAttendeeUno = this.attendeeID;
      this.objBMIncomingAttendees.feedBack = this.feedBack;
      this.objBMIncomingAttendees.condition = 1;
      this.objBMIncomingAttendees.userUno = this.login_UserID;
      this.restApi.addEditBMIncomingAttendees(this.objBMIncomingAttendees)
        .subscribe(data => {

          
          if (data != null && data != 'failure') {
            let id = parseInt(data.toString());
            //Swal.fire({
            //  type: 'success',
            //  title: 'Feedback saved successfully!.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'Thank you for your feedback');
          }
          else {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();
          }

          this.feedBack = '';


        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    }
    else {
      this.toaster.show('warning', 'Warning', 'Please enter your feedback');
    }
    return false;
  }

  AddEditSurveyEntry() {
    
   
    let objSurveyEntry = new BMIncomingSurveyEntry();

    //XML Value For KPIBenchMark Entry

    let entryItems = this.objAnswerItems;
    
    if (entryItems.length > 0) {
      objSurveyEntry.bmIncomingUno = this.visitTrackUno;
      let strXmlValue = '<roots>';
      for (var i = 0; i < entryItems.length; i++) {
        strXmlValue += "<root>";
        strXmlValue += "<BMIncomingAttendeeUno>" + this.attendeeID + "</BMIncomingAttendeeUno>";
        strXmlValue += "<SurveyUno>" + entryItems[i].QUno + "</SurveyUno>";
        strXmlValue += "<OptionUno>" + entryItems[i].optionUno + "</OptionUno>";
        strXmlValue += "<OptionRank>" + entryItems[i].optionValue + "</OptionRank>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      objSurveyEntry.xmlValue = strXmlValue;
    }
    else {
      objSurveyEntry.xmlValue = "";
    }


   
    
    this.restApi.addEditBMIncomingSurveyEntry(objSurveyEntry)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.isFeedBack = true;
          this.onUpdateStartEntry(3);
          //Swal.fire({
          //  type: 'success',
          //  title: 'Survey Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          //setTimeout(() => {
          //  this.spinner.hide();
           
          //}, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
         
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  getAttendee(id) {
    let inpValue = new bmincomingattendees();
    inpValue.visitTrackUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMIncomingAtd(inpValue)
      .subscribe(data => {
        //this.datasetAtd = data;
        
        let rtn_data:any = data;
        if (rtn_data != null && rtn_data.length > 0) {
          this.organization = rtn_data[0].organization;
          this.firstName = rtn_data[0].firstName;
          this.lastName = rtn_data[0].lastName;
          this.email = rtn_data[0].email;
          this.mobileNumber = rtn_data[0].mobileNumber;


          this.isSurvey = false;
          this.isSuccess = true;
        }
        //this.setAtdDefn();
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  onUpdateStartEntry(condition:any) {


    
      this.objBMIncomingAttendees = new bmincomingattendees();
      this.objBMIncomingAttendees.bmIncomingAttendeeUno = this.attendeeID;
    this.objBMIncomingAttendees.condition = condition;
    this.objBMIncomingAttendees.userUno = this.login_UserID;
      this.restApi.addEditBMIncomingAttendees(this.objBMIncomingAttendees)
        .subscribe(data => {

          
          //if (data != null && data != 'failure') {
          //  let id = parseInt(data.toString());
          //  //Swal.fire({
          //  //  type: 'success',
          //  //  title: 'Feedback saved successfully!.',
          //  //  showConfirmButton: false,
          //  //  timer: 1500
          //  //})
          //  this.toaster.show('success', 'Success', 'Thank you for your feedback');
          //}
          //else {
          //  //Swal.fire('Error', 'Something went wrong', 'error');
          //  this.toaster.show('error', 'Error', 'Something went wrong');
          //  this.spinner.hide();
          //}

          //this.feedBack = '';


        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    
    return false;
  }


  LoadBMIncoming() {
    

    let inpValue = new bmincoming();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.visitTrackUno ;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMIncoming(inpValue)
      .subscribe((data: any) => {
        
        if (data != null && data.length >0) {
          this.companyLogo = (data[0].companyLogo != "") ? data[0].companyLogo : "/assets/v2/img/login-logo-ring.png";
        }


        
      
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
 }


